export default class Entrada {
  constructor(id, descricao, cliente, data, notafiscal, recebeu, setor, entregou) {
    this.id = id;
    this.descricao = descricao;
    this.cliente = cliente;
    this.data = data;
    this.notafiscal = notafiscal;
    this.recebeu = recebeu;
    this.setor = setor;
    this.entregou = entregou;
  }

  update(entrada) {
    this.id = entrada.id;
    this.descricao = entrada.descricao;
    this.cliente = entrada.cliente;
    this.data = entrada.data;
    this.notafiscal = entrada.notafiscal;
    this.recebeu = entrada.recebeu;
    this.setor = entrada.setor;
    this.entregou = entrada.entregou;
  }
}
